import UserAuth from "components/AuthGaurd/UserAuth";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import HospitalTable from "components/user/hospital/HospitalTable";
import React from "react";

const Hospital = () => {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>

      {/* hero section */}
      <UserHeroSection title="Lab Result">
        <HospitalTable />
      </UserHeroSection>

      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default Hospital;
